import { useState } from 'react';
import { FaArrowLeft, FaPhone, FaEnvelope, FaMapLocationDot, FaPaperPlane } from "react-icons/fa6";

const Contact = ({ onBack, trackingNumber }) => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        subject: trackingNumber ? `Réclamation commande #${trackingNumber}` : '',
        message: ''
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // Simule l'envoi
        alert(`Message envoyé pour le dossier : ${formData.subject}`);
        // Optionnel : revenir à l'accueil après envoi
        // onBack(); 
    };

    return (
        <div className="w-full max-w-5xl animate-in slide-in-from-bottom-8 fade-in duration-500">

            {/* Bouton Retour */}
            <button
                onClick={onBack}
                className="mb-6 flex items-center gap-2 text-white/80 hover:text-white font-semibold transition-colors group"
            >
                <div className="p-2 bg-white/10 rounded-full group-hover:bg-white/20 transition-all">
                    <FaArrowLeft />
                </div>
                Retour au suivi
            </button>

            <div className="bg-white rounded-3xl shadow-2xl overflow-hidden flex flex-col md:flex-row min-h-[600px]">

                {/* Colonne Gauche : Informations */}
                <div className="md:w-5/12 bg-gradient-to-br from-blue-900 to-slate-900 p-8 md:p-12 text-white flex flex-col justify-between relative overflow-hidden">
                    <div className="absolute top-0 right-0 -mr-20 -mt-20 w-64 h-64 bg-white/5 rounded-full blur-3xl"></div>
                    <div className="absolute bottom-0 left-0 -ml-20 -mb-20 w-64 h-64 bg-blue-500/20 rounded-full blur-3xl"></div>

                    <div className="relative z-10">
                        <h2 className="text-3xl md:text-4xl font-black mb-6 tracking-tight">Contactez-nous</h2>
                        <p className="text-blue-100 mb-12 leading-relaxed text-lg">
                            Une question sur votre livraison ? Notre équipe est disponible du Samedi au Jeudi de 8h30 à 17h00.
                        </p>

                        <div className="space-y-8">
                            <div className="flex items-start gap-4">
                                <div className="p-3 bg-white/10 rounded-xl"><FaPhone className="text-xl text-blue-300" /></div>
                                <div>
                                    <h4 className="font-bold text-lg">Téléphone</h4>
                                    <p className="text-blue-100 mt-1">+213 550 00 00 00</p>
                                </div>
                            </div>

                            <div className="flex items-start gap-4">
                                <div className="p-3 bg-white/10 rounded-xl"><FaEnvelope className="text-xl text-blue-300" /></div>
                                <div>
                                    <h4 className="font-bold text-lg">Email</h4>
                                    <p className="text-blue-100 mt-1">support@samligne.com</p>
                                </div>
                            </div>

                            <div className="flex items-start gap-4">
                                <div className="p-3 bg-white/10 rounded-xl"><FaMapLocationDot className="text-xl text-blue-300" /></div>
                                <div>
                                    <h4 className="font-bold text-lg">Siège Social</h4>
                                    <p className="text-blue-100 mt-1">Zone Industrielle, Alger</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="relative z-10 mt-12 md:mt-0">
                        <div className="text-xs text-blue-300/60 uppercase tracking-widest font-bold">Samligne National Express</div>
                    </div>
                </div>

                {/* Colonne Droite : Formulaire */}
                <div className="md:w-7/12 p-8 md:p-12 bg-white">
                    <form onSubmit={handleSubmit} className="space-y-6">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            <div className="space-y-2">
                                <label className="text-sm font-bold text-slate-700 ml-1">Nom complet</label>
                                <input type="text" name="name" value={formData.name} onChange={handleChange} required
                                    className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500/50 transition-all font-medium text-slate-700" placeholder="Votre nom" />
                            </div>
                            <div className="space-y-2">
                                <label className="text-sm font-bold text-slate-700 ml-1">Téléphone</label>
                                <input type="tel" name="phone" value={formData.phone} onChange={handleChange} required
                                    className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500/50 transition-all font-medium text-slate-700" placeholder="05 XX..." />
                            </div>
                        </div>

                        <div className="space-y-2">
                            <label className="text-sm font-bold text-slate-700 ml-1">Email</label>
                            <input type="email" name="email" value={formData.email} onChange={handleChange} required
                                className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500/50 transition-all font-medium text-slate-700" placeholder="email@exemple.com" />
                        </div>

                        <div className="space-y-2">
                            <label className="text-sm font-bold text-slate-700 ml-1">Objet</label>
                            <input type="text" name="subject" value={formData.subject} onChange={handleChange} required
                                className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500/50 transition-all font-bold text-slate-800" />
                        </div>

                        <div className="space-y-2">
                            <label className="text-sm font-bold text-slate-700 ml-1">Message</label>
                            <textarea name="message" value={formData.message} onChange={handleChange} rows="4" required
                                className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500/50 transition-all font-medium text-slate-700 resize-none" placeholder="Votre message..." ></textarea>
                        </div>

                        <button type="submit" className="w-full py-4 bg-blue-600 hover:bg-blue-700 text-white font-bold rounded-xl transition-all shadow-lg hover:shadow-blue-500/30 flex items-center justify-center gap-2 mt-4">
                            <FaPaperPlane /> Envoyer
                        </button>
                    </form>
                </div>

            </div>
        </div>
    );
};

export default Contact;